import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { updatePassword } from '../../features/profile/profileSlice'

import { toast } from 'react-toastify'
import { TopHeaderSettings, CenterSettingsContainer } from './settings.styled';
import SpinnerSmall from '../SpinnerSmall'
import { useTranslation } from 'react-i18next'

function UpdatePassword(props) {
  const { t } = useTranslation('settings')
  const dispatch = useDispatch()
  const { isUpdateLoading } = useSelector((state) => state.profile)
  
  const I_STATE = {currentPassword: '', newPassword: '', newPassword2: ''}
  const [inputValue, setInputValue] = useState(I_STATE)
  const { currentPassword, newPassword, newPassword2 } = inputValue


  const handleChange = (e) => {
    setInputValue((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }))

    console.log(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if ( (currentPassword.length || newPassword || newPassword2 ) < 8   ){ return toast.error(t('accountEdit.passwordMinimum')) }
    if(newPassword === newPassword2){
      setInputValue(I_STATE)
      return dispatch(updatePassword(inputValue))
    }else if( newPassword !== newPassword2){
      return toast.error(t('accountEdit.passwordMismatch'))
    }
  }

  
  return (

      <CenterSettingsContainer>
        <TopHeaderSettings>{t('accountEdit.updatePassword')}</TopHeaderSettings>

        <div className='passwordWrap'>
          <div  className = "settingsUpdateForm"  >
            <input  
              value={currentPassword} 
              autocomplete='false' 
              type='password' 
              name='currentPassword' 
              placeholder={t('accountEdit.currentPassword')}
              onChange={handleChange} 
              />
          </div>
          <div className = "settingsUpdateForm"  >
            <input 
              value={newPassword} 
              autocomplete='off' 
              type='password' 
              name='newPassword' 
              placeholder={t('accountEdit.newPassword')}
              onChange={handleChange} 
            />
          </div>
          <div className = "settingsUpdateForm">
            <input 
              value={newPassword2}
              autocomplete='off'
              type='password'
              name='newPassword2'
              placeholder={t('accountEdit.repeatPassword')}
              onChange={handleChange} 
              />
          </div>
        
        { isUpdateLoading ? 
                    (
                      <div  className='passwordSubmitButton'>
                          <SpinnerSmall />
                      </div>
                    )
                    :
                    (
                      <button 
                        className='passwordSubmitButton' 
                        onClick={handleSubmit}
                        
                        > 
                        {t('accountEdit.submit')}
                      </button>
                    )
                  }
        </div>
      </CenterSettingsContainer>
  )
}

export default UpdatePassword
